import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FiBarChart2,
  FiBriefcase,
  FiClipboard,
  FiChevronLeft,
  FiChevronRight,
  FiGrid,
  FiUpload,
  FiMenu,
} from "react-icons/fi";
import { BUDGET_MODULE_PAGE_LINKS } from "../constants/budgetModule";
import { APP_NAME } from "../constants/app";
import { useAuth } from "../state/AuthContext";
import { useBudgetSocket } from "../state/BudgetSocketContext";
import { isAccountantUser } from "../utils/userRole";
import AppIcon from "../assets/image/icon.png";
import UserIcon from "../assets/image/user.png";

const sidebarItems = [
  {
    ...BUDGET_MODULE_PAGE_LINKS.find(
      (item) => item.path === "/budget-module/dashboard",
    ),
    icon: <FiGrid />,
  },
  {
    ...BUDGET_MODULE_PAGE_LINKS.find(
      (item) => item.path === "/import-budget",
    ),
    icon: <FiUpload />,
  },
  {
    ...BUDGET_MODULE_PAGE_LINKS.find(
      (item) => item.path === "/budget-module/departments",
    ),
    icon: <FiBriefcase />,
  },
  {
    ...BUDGET_MODULE_PAGE_LINKS.find(
      (item) => item.path === "/budget-module/planner",
    ),
    icon: <FiBarChart2 />,
  },
  {
    ...BUDGET_MODULE_PAGE_LINKS.find(
      (item) => item.path === "/budget-module/change-requests",
    ),
    icon: <FiClipboard />,
  },
].filter((item) => item.path);

const DesktopBudgetHeader = ({ showSidebar = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const budgetSocket = useBudgetSocket();
  const [collapsed, setCollapsed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const visibleSidebarItems = isAccountantUser(user)
    ? sidebarItems.filter((item) =>
      ["/budget-module/planner", "/budget-module/change-requests"].includes(
        item.path,
      ),
    )
    : sidebarItems;
  const activeItem = visibleSidebarItems.find(
    (item) => item.path === location.pathname,
  );

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <nav className="navbar-container budget-desktop-navbar">
        <div className="navbar-left-container">
          <img src={AppIcon} alt={APP_NAME} className="navbar-appLogo" />
          <p className="navbar-title">{APP_NAME} | Budget Planning</p>
        </div>

        <div className="navbar-right-container">
          <div className="navbar-rightSection">
            <p className="navbar-title">
              {user?.name || user?.email || "User"}
            </p>
            <span
              className={`budget-navbar-syncDot budget-navbar-syncDot--${budgetSocket?.status || "disconnected"}`}
            />
            <p className="navbar-last-sync">
              {budgetSocket?.statusLabel || "Disconnected - internet required"}
            </p>
            <button
              type="button"
              className="budget-navbar-userButton"
              onClick={() => setMenuOpen((currentValue) => !currentValue)}
              aria-label="Open user menu"
            >
              <img src={UserIcon} alt="User" className="navbar-userIcon" />
            </button>

            {menuOpen ? (
              <div className="budget-navbar-menu">
                {!isAccountantUser(user) ? (
                  <button
                    type="button"
                    onClick={() => navigate("/restore-backup")}
                  >
                    Restore Backup
                  </button>
                ) : null}
                <button type="button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </nav>

      {showSidebar ? (
        <>
          <aside
            className={`base-data-sidebar budget-sidebar${collapsed ? " budget-sidebar--collapsed" : ""
              }`}
          >
            <div className="budget-sidebar-menu">
              {visibleSidebarItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  title={item.label}
                  className={`budget-sidebar-item${location.pathname === item.path
                    ? " budget-sidebar-item--active"
                    : ""
                    }`}
                >
                  <span className="budget-sidebar-icon">{item.icon}</span>
                  {!collapsed ? <span>{item.label}</span> : null}
                </Link>
              ))}
            </div>
          </aside>

          <div
            className={`sidebarMenuTitle-menu budget-sidebar-title${collapsed ? " budget-sidebar-title--collapsed" : ""
              }`}
          >
            <button
              type="button"
              className="budget-sidebar-toggle"
              onClick={() => setCollapsed((currentValue) => !currentValue)}
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              <FiMenu />
              {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
            </button>
            <p className="sidebarMenuTitle-pageName">
              {activeItem?.label || "Budget Module"}
            </p>
          </div>
        </>
      ) : null}
    </>
  );
};

export default DesktopBudgetHeader;
